import api from "./api";

export const getTable = (id) => {
    return api.get(`/tables/${id}`).then((response) =>  response.data)
}
